import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  convertToChildTicket,
  createChildTicket,
  unlinkChildTicket,
} from "controller/api";
import { ChildTicketInput, CreateChildTicketInput } from "shared";

export const useConvertToChildTicket = () => {
  const queryClient = useQueryClient();
  return useMutation((value: ChildTicketInput) => convertToChildTicket(value), {
    onSuccess(data, variables, context) {
      console.log(data);
      queryClient.invalidateQueries(["ticket", variables.parentTcketId]);
    },
  });
};

export const useCreateChildTicket = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (value: CreateChildTicketInput) => createChildTicket(value),
    {
      onSuccess(data, variables, context) {
        console.log(data);
        queryClient.invalidateQueries(["ticket", variables.ticketId]);
      },
    }
  );
};

export const useUnlinkChildTicket = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({
      childTicketId,
      ticketId,
    }: {
      childTicketId: string;
      ticketId: string;
    }) => unlinkChildTicket(childTicketId),
    {
      onSuccess(data, variables, context) {
        console.log(data);
        queryClient.invalidateQueries(["ticket", variables.ticketId]);
      },
    }
  );
};
